import { render, staticRenderFns } from "./Metrics.vue?vue&type=template&id=2c4d830c&"
import script from "./Metrics.vue?vue&type=script&lang=ts&"
export * from "./Metrics.vue?vue&type=script&lang=ts&"
import style0 from "./Metrics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports